import React from 'react'
import styled from 'styled-components'
import Accordion from '../../components/Accordion'
import FormativePracticalAssessmentPanel from './FormativePracticalAssessmentPanel'

const StyledAccordion = styled(Accordion)`
  height: calc(100% - 36px);
  overflow-y: auto;
`
const SectionHeader = styled.div`
  padding: 0.5em;
  border: 1px solid black;
  background-color: ${({ theme }) => theme.main};
  .mdl-textfield {
    padding: 4px 0;
  }
  input {
    font-size: 1.5em;
  }
`

export default function FormativePracticalAssessments({ tasks, onUpdate }) {
  return (
    <StyledAccordion
      data={tasks}
      headerComponent={({ name, ...restProps }) =>
        <SectionHeader {...restProps}>
          {name}
        </SectionHeader>}>
      {tasks.map((task, i) =>
        <FormativePracticalAssessmentPanel
          key={i}
          index={i}
          task={task}
          onUpdate={onUpdate}
        />,
      )}
    </StyledAccordion>
  )
}



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/FormativePracticalAssessments/FormativePracticalAssessments.js